/** Shared class strings — the one place a primitive's look is decided. */
export const surface = "rounded-xl border border-line bg-surface shadow-sm";
export const btnBase =
  "inline-flex min-h-11 min-w-11 items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-medium no-underline transition-colors disabled:cursor-not-allowed disabled:opacity-60";
export const btnPrimary = `${btnBase} bg-accent text-on-accent hover:opacity-90`;
export const btnSecondary = `${btnBase} border border-line bg-surface text-ink hover:bg-canvas`;
export const btnDanger = `${btnBase} bg-danger text-on-accent hover:opacity-90`;
export const inputClass =
  "block w-full min-h-11 rounded-lg border border-line bg-surface px-3 py-2 text-base text-ink placeholder:text-muted md:text-sm";
export const labelClass = "block text-sm font-medium text-ink";
export const eyebrow = "text-xs font-semibold uppercase tracking-wide text-muted";
